import React from 'react';
import logoImg from '../assets/logo.jpeg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMapMarkerAlt,
  faPhoneAlt,
  faEnvelope,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn
} from '@fortawesome/free-brands-svg-icons';

export default function Footer({ navigateTo }) {
  return (
    <footer className="footer-redesign">
      <div className="footer-main-grid">

        {/* Column 1: Identity */}
        <div className="footer-column identity-column">
          <div className="footer-logo-box">
            <img src={logoImg} alt="N.D.Tools Logo" className="footer-logo" />
            {/* <div className="footer-brand-text">
              <span className="brand-main">N.D.</span>
              <span className="brand-sub">TOOLS</span>
            </div> */}
          </div>
          <p className="footer-tagline">
            Premium industrial tools and hardware solutions for global manufacturing.
            Crafting excellence with precision engineering and innovative design for over a decade.
          </p>
          <div className="highlight-box">
            <div className="highlight-item">
              <span className="gold-dot"></span> Premium Quality Guaranteed
            </div>
            <div className="highlight-item">
              <span className="gold-dot"></span> Custom Solutions Available
            </div>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column">
          <h3 className="footer-title">Quick Links</h3>
          <div className="links-card">
            <ul className="footer-links-list">
              <li onClick={() => navigateTo('home')}>
                <FontAwesomeIcon icon={faChevronRight} className="link-arrow" /> Home
              </li>
              <li onClick={() => navigateTo('about')}>
                <FontAwesomeIcon icon={faChevronRight} className="link-arrow" /> About Us
              </li>
              <li onClick={() => navigateTo('products')}>
                <FontAwesomeIcon icon={faChevronRight} className="link-arrow" /> Our Products
              </li>
              <li onClick={() => navigateTo('gallery')}>
                <FontAwesomeIcon icon={faChevronRight} className="link-arrow" /> Our Gallery
              </li>
              <li onClick={() => navigateTo('ebrochure')}>
                <FontAwesomeIcon icon={faChevronRight} className="link-arrow" /> E-Brochure
              </li>
              <li onClick={() => navigateTo('contact')}>
                <FontAwesomeIcon icon={faChevronRight} className="link-arrow" /> Contact Us
              </li>
              <li onClick={() => navigateTo('sitemap')}>
                <FontAwesomeIcon icon={faChevronRight} className="link-arrow" /> Sitemap
              </li>
            </ul>
          </div>
        </div>

        {/* Column 3: Contact Info */}
        <div className="footer-column contact-info-column">
          <h3 className="footer-title">Contact Info</h3>
          <div className="contact-list">
            <div className="contact-item">
              <div className="contact-icon-box">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <div className="contact-text">
                Sahjanand Ind Area, Street No.-1, Near Murlidhar Weigh Bridge, Rajkot - 360002
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-box">
                <FontAwesomeIcon icon={faPhoneAlt} style={{ transform: 'scaleX(-1)' }} />
              </div>
              <div className="contact-text">
                +91 97239 62464 <br /> +91 96018 42434
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-box">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <div className="contact-text">nd.tools@yahoo.in</div>
            </div>
          </div>
        </div>

        {/* Column 4: Follow Us */}
        <div className="footer-column follow-us-column">
          <h3 className="footer-title">Follow Us</h3>
          <div className="follow-card">
            <p className="follow-desc">
              Stay connected for the latest updates on our premium hardware solutions and exclusive offers.
            </p>
            <div className="social-grid">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-box">
                <FontAwesomeIcon icon={faFacebookF} />
                <span className="social-label">Facebook</span>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-box">
                <FontAwesomeIcon icon={faTwitter} />
                <span className="social-label">Twitter</span>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-box">
                <FontAwesomeIcon icon={faInstagram} />
                <span className="social-label">Instagram</span>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-box">
                <FontAwesomeIcon icon={faLinkedinIn} />
                <span className="social-label">LinkedIn</span>
              </a>
            </div>
          </div>
        </div>

      </div>

      <div className="footer-bottom-bar">
        <div className="bottom-bar-content">
          <p>© 2026 N.D.Tools. All rights reserved. || Design & Developed By <span className="designer-credit">Rudra Branding</span></p>
        </div>
      </div>
    </footer>
  );
}
